module.exports = __webpack_public_path__ + "static/media/OlafHeart.a65df2c4.gif";